$(function() {
	var anchors = {

		events: function events() {

			$('#go-to-scores').on('click', function(e) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $($(this).attr('href')).offset().top
				}, 1000);
			});

			// redirect to url HASH (if exists) 
			if (window.location.hash && $(window.location.hash)) {
				$('html, body').animate({
					scrollTop: $($(window.location.hash)).offset().top
				}, 1000);
				return false;
			}
		},

		init: function init() {
			this.events();
		}
	};

	anchors.init();
});